var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWord32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.28 31.75.01-23.8 18.06-3.1v29.98L4.28 31.75Zm28.45-8.04h-9.67v-1.87h9.67V20.6h-9.67v-1.86h9.67v-1.25h-9.67v-1.87h9.67v-1.25h-9.67V12.5h9.67v-1.24h-9.67l.02-2.95h11.7c.63-.02.75.1.73.73v21.72c0 .38-.1.7-.73.63h-11.7l-.02-3.3h9.67v-1.25h-9.67v-1.87h9.67V23.7ZM0 37.95c0 1.1.9 2 2 2h36a2 2 0 0 0 2-2L39.95 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v35.95Z",
    fill: "#2B5797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.83 14.31-1.43 7.68-1.48-7.44-2 .12-1.43 7.05-1.2-6.83-1.77.02 1.84 9.9 1.86.1 1.53-6.85.81 3.47c.24 1.18.48 2.3.7 3.5l2.1.22 2.44-11.01-1.97.07Z",
    fill: "#2B5797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWord32);
export default ForwardRef;